module.exports = __webpack_public_path__ + "papua-new-guinea.svg?f774fad8c39612e3b80aae332521649a";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/countries/svg/papua-new-guinea.svg
// module id = 263
// module chunks = 10